// src/mapcomponents/ClickLogger.js
import { useMapEvent } from 'react-leaflet';

export default function ClickLogger() {
  useMapEvent('click', (e) => {
    console.log(`🖱️ Clicked at: lat=${e.latlng.lat}, lon=${e.latlng.lng}`);
  });

  return null;
}
